<template>
  <div class="container mt-lg-5 mb-5">
    <div class="d-flex flex-row">
      <div class="d-flex flex-row align-items-center justify-content-center gap-2 mb-3">
        <router-link to="/personas" class="btn d-flex align-items-center justify-content-center p-0 pt-1 tooltip-container">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 12H18M6 12L11 7M6 12L11 17" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="tooltip-text">{{ $t('volver') }}</span>
        </router-link>
        <h2 class="m-0">{{ $t('agregarPersona') }}:</h2>
      </div>
    </div>
    <div>
      <form @submit.prevent="saveChanges" class="d-flex flex-column gap-2">
        <div class="d-flex flex-lg-row flex-column gap-2">
          <p class="m-0 fs-7 w-100"><strong>{{ $t('apellido') }}:</strong> <input type="text" v-model="persona.Apellido" class="form-control sombra-sm" maxlength="100" required/></p>
          <p class="m-0 fs-7 w-100"><strong>{{ $t('nombre') }}:</strong> <input type="text" v-model="persona.Nombre" class="form-control sombra-sm" maxlength="100" required/></p>
        </div>

        <div class="d-flex flex-lg-row flex-column gap-2">
          <p class="m-0 fs-7 w-100"><strong>{{ $t('nroDni') }}:</strong> <input type="text" v-model="dniInput" @input="handleDniInput" class="form-control sombra-sm"/></p>

          <p class="m-0 fs-7 w-100"><strong>{{ $t('pasaporte') }}:</strong> <input type="text" v-model="persona.Pasaporte" class="form-control sombra-sm"/></p>
        </div>

        <div class="d-flex flex-lg-row flex-column gap-2">
          <p class="m-0 fs-7 w-100"><strong>{{ $t('fechaNacimiento') }}:</strong> <input type="date" v-model="persona.FechaNac" class="form-control sombra-sm"/></p>

          <!-- Genero -->
          <div class="d-flex flex-column w-100">
            <label for="genero" class="form-label m-0 fs-7"><strong>{{ $t('genero') }}*:</strong></label>
            <div class="select-wrapper w-100 m-0">
              <select id="genero" v-model="persona.Genero" class="form-select sombra-sm" required>
                <option value="M">{{ $t('masculino') }}</option>
                <option value="F">{{ $t('femenino') }}</option>
                <option value="X">{{ $t('noBinario') }}</option>
                <option value="-">{{ $t('prefieroNoDecirlo') }}</option>
              </select>
              <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
              </svg>
            </div>
          </div>
        </div>
        <!-- Email - Personales -->
        <div class="d-flex flex-column">
          <label for="email" class="form-label m-0 fs-7"><strong>{{ $t('emailsPersonales') }}:</strong></label>
          <div v-for="(email, index) in persona?.Email?.filter(email => email.TipoEmail == 'Personal')" :key="'email' + index" class="m-0 fs-7 d-flex flex-row gap-2 mb-2">
            <input type="email" v-model="email.email" class="form-control sombra-sm"/>
          </div>
          <button type="button" class="btn btn-primary mt-2 sombra-sm" @click="addEmail">{{ $t('agregarEmail') }}</button>
        </div>

        <label class="form-label m-0 fs-7"><strong>{{ $t('roles') }}:</strong></label>
        <div class="d-flex flex-wrap gap-2">
          <div
            v-for="rol in roles"
            :key="rol.IdRol"
            class="form-check-pill"
            :class="{ 'checked': selectedRoleIds.includes(rol.IdRol) }"
            @click="toggleRol(rol.IdRol)">
            <span>{{ rol.Rol }}</span>
          </div>
        </div>
        <!-- <div class="d-flex flex-wrap gap-2">
          <div
            class="form-check-pill"
            :class="{ 'checked': empleado }"
              @click="empleado = !empleado;">
            <span>{{ $t('empleado') }}</span>
          </div>
          <div
            class="form-check-pill"
            :class="{ 'checked': profesor }"
              @click="profesor = !profesor">
            <span>{{ $t('profesor') }}</span>
          </div>
          <div
            class="form-check-pill"
            :class="{ 'checked': alumno }"
              @click="alumno = !alumno">
            <span>{{ $t('alumno') }}</span>
          </div>
          <div
            class="form-check-pill"
            :class="{ 'checked': familiar }"
              @click="familiar = !familiar; persona.Roles">
            <span>{{ $t('familiar') }}</span>
          </div>
          <div
            class="form-check-pill"
            :class="{ 'checked': agds }"
              @click="agds = !agds">
            <span>{{ $t('agds') }}</span>
          </div>
          <div
            class="form-check-pill"
            :class="{ 'checked': comisionDirectiva }"
              @click="comisionDirectiva = !comisionDirectiva">
            <span>{{ $t('comisionDirectiva') }}</span>
          </div>
        </div> -->
        <!-- Email - Profesional -->
        <div v-if="isEmpleado || isProfesor || isComisionDirectiva || isPasante || isPracticante" class="d-flex flex-column">
          <label for="email" class="form-label m-0 fs-7"><strong>{{ $t('emailProfesional') }}:</strong></label>
          <div v-for="(email, index) in persona?.Email?.filter(email => email.TipoEmail == 'Profesional')" :key="'email' + index" class="m-0 fs-7 d-flex flex-row gap-2 mb-2">
            <input type="email" v-model="email.email" class="form-control sombra-sm" maxlength="100" required/>
          </div>
        </div>
        
        <div v-if="isEmpleado || isProfesor || isPasante || isPracticante" class="d-flex flex-lg-row flex-column gap-2">
          <p class="m-0 fs-7 w-100"><strong>{{ $t('cargo') }}:</strong> <input type="text" v-model="persona.Cargo" class="form-control sombra-sm" maxlength="50"/></p>
          
          <!-- Nivel/Sector -->
          <div class="d-flex flex-column w-100">
            <label for="estadoCivil" class="form-label m-0 fs-7"><strong>{{ $t('nivelSector') }}:</strong></label>
            <div class="select-wrapper">
              <select id="estadoCivil" v-model="selectedNivelSectorId" class="form-select sombra-sm">
                <option v-for="(nivelSector) in nivelesSectores.Listas" :key="nivelSector.IdLista" :value="nivelSector.IdLista">{{ nivelSector.Nombre }}</option>
              </select>
              <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="d-flex flex-lg-row flex-column gap-2">
          <p v-if="isEmpleado" class="m-0 fs-7 w-100"><strong>{{ $t('legajo') }}:</strong> <input type="number" v-model="persona.LegajoId" class="form-control sombra-sm"/></p>
          <!-- <div class="d-flex flex-lg-row flex-column gap-2"> -->
          <p v-if="isProfesor" class="m-0 fs-7 w-100"><strong>{{ $t('siglaUntis') }}:</strong> <input type="text" v-model="persona.SiglaUntis" class="form-control sombra-sm" maxlength="50"/></p>
          <div v-if="isProfesor" class="m-0 fs-7 w-100 d-flex flex-column">
            <p class="m-0 fs-7 w-100"><strong>{{ $t('tipoDocente') }}:</strong></p>
            <div class="select-wrapper w-100 position-relative">
              <select v-model="persona.TipoDocente" class="form-select fondo-terciario sombra-sm">
                <option :value="null">{{ $t('ninguno') }}</option>
                <option v-for="tipo in tiposDocente" :key="tipo.codigo" :value="tipo.codigo">
                  {{ tipo.codigo }}
                </option>
              </select>
              <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
              </svg>
            </div>
          </div>
          <!-- </div> -->
          <p v-if="isEmpleado || isProfesor || isAlumno || isPasante || isPracticante" class="m-0 fs-7 w-100"><strong>{{ $t('fechaIngreso') }}:</strong> <input type="date" v-model="persona.FechaIngreso" class="form-control sombra-sm"/></p>
        </div>
        <div class="d-flex flex-row gap-2">
          <button class="btn btn-success mt-3 sombra-sm" type="submit">{{ $t('guardar') }}</button>
          <router-link to="/personas" class="btn btn-secondary mt-3 sombra-sm">{{ $t('cancelar') }}</router-link>
          <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
            <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { ref, onMounted, computed } from 'vue';
  import {useStore} from "vuex";
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';

export default {
  name: 'AgregarPersona',
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    var hasAgregarPersonaPermission = ref(false);
    let selectedNivelSectorId = ref('');
    const nivelesSectores = ref({});
    const roles = ref([]);
    const selectedRoleIds = ref([]);

    let loading = ref(false);
    const persona = ref({
      IdPersona: '00000000-0000-0000-0000-000000000000',
      Apellido: '',
      Nombre: '',
      Dni: null,
      FechaNac: null,
      Genero: null,
      NivelSector: null,
      Cargo: null,
      SiglaUntis: null,
      //FechaNac: new Date(),
      IdEstado: '955efa1d-c927-425b-a1f2-425ded375dbe',
      Email: [{
        IdPersona: '00000000-0000-0000-0000-000000000000',
        IdEmail: '00000000-0000-0000-0000-000000000000',
        email: null,
        TipoEmail: 'Profesional',
      },
      {
        IdPersona: '00000000-0000-0000-0000-000000000000',
        IdEmail: '00000000-0000-0000-0000-000000000000',
        email: null,
        TipoEmail: 'Personal',
      }],
      PersonasRoles: []
    });

    const checkAuth = async  () => {
      let permisoAComprobar = 'AgregarPersonas'
      if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
        hasAgregarPersonaPermission.value = true;
      }else{
        console.log('No tiene permiso de ingresar');
        await router.push('/personas');
      }
    };

    const tiposDocente = ref([
      { "codigo": "ADLK-Enviado/a Alemán" },
      { "codigo": "AUL-ES-Ayudante de Laboratorios" },
      { "codigo": "AUM-ES-Ayudante de Medios" },
      { "codigo": "BIB-Bibliotecario/a" },
      { "codigo": "BPLK-Contratado/a Alemán" },
      { "codigo": "CAT-Coord. de Alemán Transversal" },
      { "codigo": "CCC-ES-Coordinador/a de Convivencia" },
      { "codigo": "CEF-Coordinador/a Educación Física" },
      { "codigo": "CMT-Coord. de Matemática Transversal" },
      { "codigo": "CND-Cargo no docente" },
      { "codigo": "DCL-Docente con licencia" },
      { "codigo": "DED-Extraprogramáticos deportivos" },
      { "codigo": "DEF-Docente Educación Física" },
      { "codigo": "DEX-Extraprogramáticos" },
      { "codigo": "DFT-ES-Docente Full Time" },
      { "codigo": "DGG-Director/a General" },
      { "codigo": "DIR-Director/a" },
      { "codigo": "DOLK-Deutsche Ortslehrkraft" },
      { "codigo": "DPT-ES-Docente Part-Time" },
      { "codigo": "DSU-Docente suplente" },
      { "codigo": "EOE-Equipo de Orientación Escolar" },
      { "codigo": "EXD-Ex-Docente" },
      { "codigo": "JIC-Jefe/a de integración curricular" },
      { "codigo": "MAA-Maestro/a de Alemán" },
      { "codigo": "MAB-Maestro/a de Bilingüe" },
      { "codigo": "MAC-Maestro/a de Castellano" },
      { "codigo": "MAI-Maestro/a de Inglés" },
      { "codigo": "MAM-Maestro/a de Música" },
      { "codigo": "MAN-Maestro/a de Ciencias Naturales" },
      { "codigo": "MAS-Maestro/a Secretario/a" },
      { "codigo": "MEA-Maestro/a de Artística" },
      { "codigo": "MI-Maestro/a de Educación Inicial" },
      { "codigo": "MMA-Maestro/a de Matemática" },
      { "codigo": "MSU-Maestro/a Suplente" },
      { "codigo": "OLK-Ortslehrkraft" },
      { "codigo": "PR-Preceptor/a" },
      { "codigo": "PRS-Prosecretario/a Pedagógico/a" },
      { "codigo": "SCR-Secretario/a" },
      { "codigo": "SEP-Secretario/a Pedagógico/a" },
      { "codigo": "VDA-Vicedirector/a Alemán" },
      { "codigo": "VDG-Vicedirector/a General" },
      { "codigo": "VDI-Vicedirector/a" }
    ]);

    const fetchRoles = async () => {
      try {
        loading.value = true
        const response = await api.get(`api/Roles`);
        roles.value = response.data.filter(r => r.Oculto != true); // Asumiendo que la respuesta contiene un array de usuarios
        console.log(roles.value)
        loading.value = false
      } catch (error) {
        console.error('Error al obtener usuarios:', error);
        loading.value = false
      }
    };

    // --- Computed Properties para la UI Condicional ---
    // Chequeamos si entre los roles seleccionados se encuentra Empleado, Profesor o Alumno
    const isEmpleado = computed(() => {
      const empRole = roles.value.find(r => r.Rol?.toLowerCase() === 'empleado');
      return empRole ? selectedRoleIds.value.includes(empRole.IdRol) : false;
    });

    const isProfesor = computed(() => {
      const profRole = roles.value.find(r => r.Rol?.toLowerCase() === 'profesor');
      return profRole ? selectedRoleIds.value.includes(profRole.IdRol) : false;
    });

    const isComisionDirectiva = computed(() => {
      const profRole = roles.value.find(r => r.Rol?.toLowerCase() === 'comision directiva');
      return profRole ? selectedRoleIds.value.includes(profRole.IdRol) : false;
    });

    const isPasante = computed(() => {
      const profRole = roles.value.find(r => r.Rol?.toLowerCase() === 'pasante');
      return profRole ? selectedRoleIds.value.includes(profRole.IdRol) : false;
    });

    const isPracticante = computed(() => {
      const profRole = roles.value.find(r => r.Rol?.toLowerCase() === 'practicante');
      return profRole ? selectedRoleIds.value.includes(profRole.IdRol) : false;
    });

    const isAlumno = computed(() => {
      const aluRole = roles.value.find(r => r.Rol?.toLowerCase() === 'alumno');
      return aluRole ? selectedRoleIds.value.includes(aluRole.IdRol) : false;
    });

    // Función para marcar/desmarcar roles
    const toggleRol = (idRol) => {
      const index = selectedRoleIds.value.indexOf(idRol);
      if (index > -1) {
        selectedRoleIds.value.splice(index, 1);
      } else {
        selectedRoleIds.value.push(idRol);
      }
    };

    const saveChanges = async () => {
      try {
        loading.value = true;

        // Chequea si tiene asignado al menos un rol
        if(selectedRoleIds.value.length === 0){
          alert('La persona debe tener al menos un rol asignado.');
          loading.value = false;
          return;
        }

        // Asignar los roles seleccionados dinámicamente
        persona.value.PersonasRoles = selectedRoleIds.value.map(idRol => {
          // Identificar si este idRol pertenece al rol "Empleado"
          const roleData = roles.value.find(r => r.IdRol === idRol);
          const roleName = roleData ? roleData.Nombre?.toLowerCase() : '';
          const isEmpRole = roleName === 'empleado';
          
          // Solo asignamos el LegajoId si es Empleado
          const legajoAsString = persona.value.LegajoId != null ? String(persona.value.LegajoId) : null;

          return {
            IdPersona: '00000000-0000-0000-0000-000000000000',
            IdRol: idRol,
            LegajoId: isEmpRole ? legajoAsString : null,
            FechaHora: null
          };
        });

        //Chequea si tiene DNI o Pasaporte
        if(!persona.value.Dni && !persona.value.Pasaporte){
          alert('La persona debe tener al menos un documento de identificación (DNI o Pasaporte).');
          loading.value = false;
          return;
        }

        //Si el email personal esta vacio lo setea en null para que no de error al guardar
        if(persona.value.Email.some(email => email.TipoEmail === 'Personal' && !email.email)){
          persona.value.Email = persona.value.Email.filter(email => !(email.TipoEmail === 'Personal' && !email.email));
        }

        //Si el email profesional esta vacio lo setea en null para que no de error al guardar
        if(persona.value.Email.some(email => email.TipoEmail === 'Profesional' && !email.email)){
          persona.value.Email = persona.value.Email.filter(email => !(email.TipoEmail === 'Profesional' && !email.email));
        }

        if(persona.value.PersonasListas){
          const existingNivelSectorPog = persona.value.PersonasListas.find(pog =>
            pog.Lista &&
            pog.Lista.IdGrupo === '555f125b-184f-4b46-97b4-7d4b54a56858'
          );
        
          if (existingNivelSectorPog) {
            existingNivelSectorPog.IdLista = selectedNivelSectorId.value
          }
        }
        else if(selectedNivelSectorId.value != ''){
          if(persona.value.PersonasOpcionGrupo == null){
            persona.value.PersonasOpcionGrupo = []
          }
          const personasOpcionGrupo = {
            IdPersona: user?.value.idPersona,
            IdLista: selectedNivelSectorId.value
          }
          persona.value.PersonasListas == null ? persona.value.PersonasListas = [personasOpcionGrupo] : persona.value.PersonasListas.push(personasOpcionGrupo)
        }
        convertEmptyToNull(persona.value)
        console.log(persona.value)
        const response = await api.post(`api/Persona`, persona.value);
        console.log('response:')
        console.log(response)
        loading.value = false;
        await router.push('/personas/verDatosPersona?id='+response.data.IdPersona)
      } catch (error) {
        loading.value = false;
        console.error('Error al guardar los cambios:', error);
        alert('Hubo un problema al guardar los datos. \n'+ error.response.data.message);
      }
    };

    const convertEmptyToNull = (obj) => {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === "") {
          obj[key] = null;
        }
      });
    }
    
    const fetchNivelSector = async () => {
      try {
        const response = await api.get(`api/Grupos/555F125B-184F-4B46-97B4-7D4B54A56858`);
        nivelesSectores.value = response.data; // Asumiendo que la respuesta contiene un array de usuarios
        console.log(nivelesSectores.value)
        console.log('asd')
      } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
      }
    };

    //Función que limpia una cadena dejando solo dígitos.
    const cleanDni = (value) => {
      const onlyNumbers = String(value || '').replace(/\D/g, ''); 
  
      // 2. Limita la longitud máxima a 8 caracteres
      return onlyNumbers.slice(0, 8); 
    };

    //Función que formatea una cadena de dígitos con puntos.
    const formatDni = (value) => {
      // 1. Limpiamos por si acaso
      const dniSinPuntos = cleanDni(value);
      
      // 2. Aplicamos la expresión regular para insertar puntos cada 3 dígitos desde la derecha
      return dniSinPuntos.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    /**
     * Función para manejar el evento @input.
     * Esto actualiza persona.Dni con el valor limpio.
     */
    const handleDniInput = (event) => {
        const rawValue = event.target.value;
        
        // 1. Limpiamos el valor (solo números, máximo 8)
        const cleanValue = cleanDni(rawValue);
        
        // 2. Actualizamos la variable original (persona.Dni)
        persona.value.Dni = cleanValue;
        
        // 3. OBLIGATORIO: Forzamos la actualización visual del input 
        //    con el valor formateado y limpio para "rechazar" la letra.
        event.target.value = formatDni(cleanValue);
    };


    /**
     * Propiedad computada (SOLO GETTER) para ligar la visualización del input.
     * Es necesario para que Vue sepa que el input depende de persona.Dni
     */
    const dniInput = computed(() => {
        return formatDni(persona.value.Dni);
    });

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      checkAuth();
      fetchNivelSector();
      fetchRoles();
    });

    const addEmail = () => {
      // Añadir un nuevo objeto email vacío
      persona.value.Email.push({ email: "", IdPersona: '00000000-0000-0000-0000-000000000000',
        IdEmail: '00000000-0000-0000-0000-000000000000', TipoEmail: 'Personal' });
    };

    return {
      checkAuth,
      t,
      persona,
      loading,
      saveChanges,
      addEmail,
      nivelesSectores,
      selectedNivelSectorId,
      cleanDni,
      formatDni,
      dniInput,
      handleDniInput,
      tiposDocente,
      roles,
      selectedRoleIds,
      toggleRol,
      isEmpleado,
      isProfesor,
      isAlumno,
      isComisionDirectiva,
      isPasante,
      isPracticante,
    };
  },
};
</script>

<style>
.permissions-list {
  margin-top: 10px;
}
</style>
